<template>
  <ElevationProfile
    :coordinates="activeCoordinates"
    :get-map="getMap"
    :collapsible="false"
    :expandable="false"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import mapboxgl from 'mapbox-gl';
import ElevationProfile from '../../components/ElevationProfile.vue';

export default defineComponent({
  name: 'TrailOverviewMapLineChart',

  components: { ElevationProfile },

  computed: {
    // Reactive view of the module state; recomputes when the trail loads or a
    // measurement is drawn/cleared. Cast through `any` to sidestep the Options
    // API `$store` typing gap without dragging a string index signature (from
    // mapState) over the sibling getters below.
    trailState(): any {
      return (this as any).$store.state.trailOverviewMap;
    },

    // Raw [lon, lat, ele] coordinates for the trail. buildElevationChartData
    // (inside ElevationProfile) owns distance, sampling and unit conversion, so
    // the bespoke `createChartData` getter is no longer needed here.
    trailCoordinates(): number[][] {
      const state = this.trailState;
      if (!state.trail && !state.isForStage) return [];
      try {
        const feature = (this as any).$store.getters['trailOverviewMap/getTrailGeoJsonFeature'];
        return feature?.geometry?.coordinates ?? [];
      } catch {
        return [];
      }
    },

    // Raw coordinates for the currently measured slice, when measuring.
    measuredCoordinates(): number[][] {
      return this.trailState.measuredGeoJson?.geometry?.coordinates ?? [];
    },

    // Show the measured slice while measuring, otherwise the full trail.
    activeCoordinates(): number[][] {
      return this.measuredCoordinates.length
        ? this.measuredCoordinates
        : this.trailCoordinates;
    },
  },

  methods: {
    // Hover → map: ElevationProfile manages the marker internally via this
    // accessor, replacing the old local `elevationMarker` singleton.
    getMap(): mapboxgl.Map | null {
      return window.map ?? null;
    },
  },
});
</script>
